// extracted by css-extract-rspack-plugin
export default {"disabled":"disabled-FsIIon"};